export default __webpack_public_path__ + "static/media/DNo.38-8.2aa2c2cc.jpg";